import React from 'react'
import {
    Link
} from 'react-router-dom';
import CropYield from './CropYield';
import Drought from './Drought';

const Home = () => {
    
    return (
        <>
            <div className="bg-[#4799B5] text-white text-xl py-5 font-Gill font-bold">
                <div className="max-w-8xl mx-[2rem] px-2 sm:px-6 lg:px-8 space-x-8">
                    <Link to="/">Drought Condition</Link>
                    <Link to="cropYield"  >Crop Yield</Link>
                </div>

            </div>
            <Drought />
        </>
    )
}

export default Home